import Navbar from "./components/navbar";

import React from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Globe, ShieldCheck, BarChart2 } from "lucide-react";
import "./components/css/AboutPage.css";
import farmImage from "./assets/Aboutusimg.jpg";
import Footer from "./components/Footer";

const AboutPage = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Leaf size={40} className="feature-icon" />,
      title: "Sustainable Farming",
      description:
        "We promote eco-friendly agricultural practices that protect the environment while maximizing yields.",
    },
    {
      icon: <Globe size={40} className="feature-icon" />,
      title: "Market Access",
      description:
        "Connecting farmers directly with buyers to ensure fair prices and reduce middlemen.",
    },
    {
      icon: <ShieldCheck size={40} className="feature-icon" />,
      title: "Quality Assurance",
      description:
        "Rigorous standards to ensure only the best produce reaches your table.",
    },
    {
      icon: <BarChart2 size={40} className="feature-icon" />,
      title: "Data-Driven",
      description:
        "Using analytics to help farmers make informed decisions about their crops.",
    },
  ];


  return (
    <div className="about-page">
      <Navbar />
      <section className="about-hero" style={{ backgroundImage: `url(${farmImage})` }}>
        <div className="hero-content">
          <h1>Growing the Future of Agriculture</h1>
          <p>
            An AI-powered smart farming initiative built by BrainK, UNN, and APWEN to transform agriculture in Nigeria.

          </p>
          <button
            className="primary-button"
            onClick={() => navigate("/signup")}
          >
            Access Agricverse - Farm management platform
          </button>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="our-story">
        <div className="story-content">
          <h2>Our Story</h2>
          <div className="story-image">
            <img src={farmImage} alt="Our farm" />
          </div>
          <div className="story-text">
            <p>
              AgricVerse is an integrated smart farming initiative designed to transform agricultural practices through advanced artificial intelligence, practical research, and community-centered technology deployment. The project is driven by a collaborative partnership between BrainK, the University of Nigeria, Nsukka (UNN), and the Association of Professional Women Engineers of Nigeria (APWEN), each contributing complementary strengths that make AgricVerse both innovative and impactful.
            </p>
            <p>
              BrainK leads the technological backbone of AgricVerse, developing tailored AI systems and intelligent tools that address real challenges faced by farmers and agribusinesses. Our expertise in machine learning, computer vision, predictive analytics, and automated decision support enables the platform to diagnose crop diseases, monitor field conditions, support precision irrigation, and provide actionable insights that improve productivity and reduce losses. Every system within AgricVerse is built to be practical, reliable, and accessible for real-world use across diverse farming environments.
            </p>
            <p>
              UNN supports the project through strong academic research, scientific validation, and field-based experimentation. This collaboration ensures that AgricVerse is grounded in evidence, enriched by ongoing research, and continuously refined to meet global standards of agricultural innovation. With UNN’s research capacity, the project benefits from rigorous testing, data quality assurance, and continuous technological improvement.
            </p>
            <p>APWEN plays a key role as the technology linkage agency, connecting AgricVerse to rural women, cooperatives, and smallholder communities. Through APWEN’s outreach network and empowerment programs, the project ensures that advanced technology reaches the populations that need it most. This connection helps bridge the digital divide, increases adoption of smart farming tools, and promotes inclusive participation, especially among women farmers who form a critical part of the agricultural workforce.</p>
            <p>Together, BrainK, UNN, and APWEN are building AgricVerse as a platform that embodies innovation, inclusiveness, and sustainability. Our shared mission is to create a modern agricultural ecosystem where farmers have the tools and knowledge to make informed decisions, improve yields, reduce risks, and build resilient livelihoods. AgricVerse represents our commitment to advancing agriculture through intelligent solutions that serve both people and communities.</p>
          </div>

        </div>
      </section>

      {/* Our Mission Section */}
      <section className="our-mission">
        <div className="mission-content">
          <h2>Our Mission</h2>
          <p className="mission-statement">
            To empower farmers with technology, knowledge, and market access
            while providing consumers with fresh, traceable, and sustainably
            grown agricultural products.
          </p>
          <div className="feature-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card-abt">
                <div className="feature-icon-container">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/*   <section className="our-team">
        <div className="team-content">
          <h2>Meet Our Team</h2>
          <p>The passionate individuals driving our vision forward</p>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-image-container">
                  <img src={teamImage} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
 */}

      <Footer />
    </div>
  );
};

export default AboutPage;
